var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal", attrs: { id: "sendEmail" } }, [
    _c("div", { staticClass: "modal-dialog modal-lg" }, [
      _c("div", { staticClass: "modal-content" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "modal-body" }, [
          _c("ul", [
            _vm._m(1),
            _vm._v(" "),
            _c("li", [
              _vm._v("To: "),
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      return _vm.searchForPerson()
                    }
                  }
                },
                [_vm._v("[Users]")]
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedEmailTo,
                    expression: "selectedEmailTo"
                  }
                ],
                attrs: {
                  type: "text",
                  name: "emailTo",
                  id: "emailTo",
                  value: "selectedEmailTo"
                },
                domProps: { value: _vm.selectedEmailTo },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.selectedEmailTo = $event.target.value
                  }
                }
              })
            ]),
            _c("span", { staticClass: "checkbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.saveToAddressBook,
                    expression: "saveToAddressBook"
                  }
                ],
                attrs: {
                  type: "checkbox",
                  id: "savetobookmarks",
                  name: "savetobookmarks"
                },
                domProps: {
                  checked: Array.isArray(_vm.saveToAddressBook)
                    ? _vm._i(_vm.saveToAddressBook, null) > -1
                    : _vm.saveToAddressBook
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.saveToAddressBook,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.saveToAddressBook = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.saveToAddressBook = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.saveToAddressBook = $$c
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "savetobookmarks" } }, [
                _vm._v("Save in")
              ])
            ]),
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    return _vm.openAddressBook()
                  }
                }
              },
              [_vm._v("[address book]")]
            ),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c("li", [
              _c(
                "textarea",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.notifyMessage,
                      expression: "notifyMessage"
                    }
                  ],
                  attrs: { name: "emailMessage", id: "emailMessage" },
                  domProps: { value: _vm.notifyMessage },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.notifyMessage = $event.target.value
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.notifyMessage))]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _vm.viewListOfUsers
                  ? _c(
                      "button",
                      {
                        staticClass: "btn",
                        attrs: {
                          name: "add_to_the_email_list",
                          id: "add_to_the_email_list"
                        },
                        on: { click: _vm.addToTheEmailList }
                      },
                      [_vm._v("Add to the email list")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewListOfUsers
                  ? _c("b-table", {
                      staticClass: "list-table",
                      attrs: {
                        "sort-by": _vm.sort_by,
                        "sort-desc": _vm.sort_desc,
                        fields: _vm.fields,
                        items: _vm.users,
                        "show-empty": ""
                      },
                      on: {
                        "update:sortBy": function($event) {
                          _vm.sort_by = $event
                        },
                        "update:sort-by": function($event) {
                          _vm.sort_by = $event
                        },
                        "update:sortDesc": function($event) {
                          _vm.sort_desc = $event
                        },
                        "update:sort-desc": function($event) {
                          _vm.sort_desc = $event
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "empty",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                                No user available.\n                            "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(checkbox)",
                            fn: function(data) {
                              return [
                                _c("span", { staticClass: "checkbox" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedUserEmailAccounts,
                                        expression: "selectedUserEmailAccounts"
                                      }
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      name: "user[]",
                                      id: "user-" + data.item.id
                                    },
                                    domProps: {
                                      value:
                                        data.item.name +
                                        "<" +
                                        data.item.email +
                                        ">",
                                      checked: Array.isArray(
                                        _vm.selectedUserEmailAccounts
                                      )
                                        ? _vm._i(
                                            _vm.selectedUserEmailAccounts,
                                            data.item.name +
                                              "<" +
                                              data.item.email +
                                              ">"
                                          ) > -1
                                        : _vm.selectedUserEmailAccounts
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.selectedUserEmailAccounts,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v =
                                              data.item.name +
                                              "<" +
                                              data.item.email +
                                              ">",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.selectedUserEmailAccounts = $$a.concat(
                                                [$$v]
                                              ))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.selectedUserEmailAccounts = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.selectedUserEmailAccounts = $$c
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    { attrs: { for: "user-" + data.item.id } },
                                    [_vm._v(" ")]
                                  )
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1864214858
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewAddressBook
                  ? _c(
                      "button",
                      {
                        staticClass: "btn",
                        attrs: {
                          name: "add_to_the_email_from_address_book",
                          id: "add_to_the_email_from_address_book"
                        },
                        on: { click: _vm.addToTheEmailListFromAddressBook }
                      },
                      [_vm._v("Add to the email list")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewAddressBook
                  ? _c("b-table", {
                      staticClass: "list-table",
                      attrs: {
                        "sort-by": _vm.sort_by,
                        "sort-desc": _vm.sort_desc,
                        fields: _vm.fields,
                        items: _vm.addressBook,
                        "show-empty": ""
                      },
                      on: {
                        "update:sortBy": function($event) {
                          _vm.sort_by = $event
                        },
                        "update:sort-by": function($event) {
                          _vm.sort_by = $event
                        },
                        "update:sortDesc": function($event) {
                          _vm.sort_desc = $event
                        },
                        "update:sort-desc": function($event) {
                          _vm.sort_desc = $event
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "empty",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                                No user available.\n                            "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(checkbox)",
                            fn: function(data) {
                              return [
                                _c("span", { staticClass: "checkbox" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.addressBookName,
                                        expression: "addressBookName"
                                      }
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      name: "addressBookName[]",
                                      id: "addressBookName-" + data.item.id
                                    },
                                    domProps: {
                                      value:
                                        data.item.name +
                                        "<" +
                                        data.item.email +
                                        ">",
                                      checked: Array.isArray(
                                        _vm.addressBookName
                                      )
                                        ? _vm._i(
                                            _vm.addressBookName,
                                            data.item.name +
                                              "<" +
                                              data.item.email +
                                              ">"
                                          ) > -1
                                        : _vm.addressBookName
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.addressBookName,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v =
                                              data.item.name +
                                              "<" +
                                              data.item.email +
                                              ">",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.addressBookName = $$a.concat(
                                                [$$v]
                                              ))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.addressBookName = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.addressBookName = $$c
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for: "addressBookName-" + data.item.id
                                      }
                                    },
                                    [_vm._v(" ")]
                                  )
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3551688989
                      )
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn",
              attrs: { name: "viewListOfCars", id: "viewListOfCars" },
              on: { click: _vm.viewSElectedCars }
            },
            [_vm._v("View selected cars")]
          ),
          _vm._v(" "),
          _vm._m(4)
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c(
              "button",
              {
                staticClass: "btn",
                attrs: { name: "sendEmail" },
                on: { click: _vm.sendEmail }
              },
              [_vm._v("Send Email")]
            )
          ])
        ]),
        _vm._v(" "),
        _vm._m(5)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "modal-title" }, [
        _vm._v("Select users and recommend "),
        _c("a", { attrs: { href: "" } }, [_vm._v("the vehicles")])
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: { type: "button", "data-dismiss": "modal" }
        },
        [_vm._v("×")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("From: "),
      _c("input", {
        attrs: {
          type: "text",
          name: "from",
          id: "Emailfrom",
          value: "test@test.com",
          readonly: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("Subject: "),
      _c("input", {
        attrs: {
          type: "text",
          name: "emailSubject",
          id: "emailSubject",
          value: "List of Cars"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("Reply To: "),
      _c("input", {
        attrs: {
          type: "text",
          name: "replyTo",
          id: "replyTo",
          value: "",
          readonly: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("iframe", { attrs: { width: "100%" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-danger",
          attrs: { type: "button", "data-dismiss": "modal" }
        },
        [_vm._v("Close")]
      )
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f7c973a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f7c973a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleRecommendationSendEmailModal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1f7c973a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleRecommendationSendEmailModal.vue
// module chunks = 0